import React from 'react'
import AccountTransactions from 'src/app/AccountTransactions/AccountTransactions'
import { AppLocation, SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { accountTransactionsRouteProps } from 'src/navigation/routeProps'

const AccountTransactionsAppRoute: AppRoute = {
  id: AppLocation.AccountTransactions,
  routeProps: accountTransactionsRouteProps,
  component: <AccountTransactions />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default AccountTransactionsAppRoute
